'use client';
import React, { useState, useMemo } from 'react';
import { Search, Grid, List, Plus, QrCode } from 'lucide-react';
import PlotTable from './PlotTable';
import PlotQRModal from './PlotQRModal';
import PlotTransferModal from './PlotTransferModal';

export type GravePlot = {
  id: string;
  plotId: string;
  cemetery: string;
  block: string;
  row: string;
  plotNumber: string;
  gpsLat: string;
  gpsLng: string;
  status: string;
  deceasedName: string;
  burialDate: string;
  ownerName: string;
  ownerContact: string;
  reservedUntil: string;
  size: string;
  section: string;
};

export const gravePlots: GravePlot[] = [
  { id: 'plot-001', plotId: 'NYD-MTH-B1-R1-001', cemetery: 'Mthatha', block: 'B1', row: 'R1', plotNumber: '001', gpsLat: '-31.5892', gpsLng: '28.7849', status: 'occupied', deceasedName: 'Thandi Nxumalo', burialDate: '02 Aug 2026', ownerName: 'Musa Nxumalo', ownerContact: '073 456 7890', reservedUntil: '—', size: 'Standard', section: 'General' },
  { id: 'plot-002', plotId: 'NYD-MTH-B1-R1-002', cemetery: 'Mthatha', block: 'B1', row: 'R1', plotNumber: '002', gpsLat: '-31.5893', gpsLng: '28.7850', status: 'available', deceasedName: '—', burialDate: '—', ownerName: '—', ownerContact: '—', reservedUntil: '—', size: 'Standard', section: 'General' },
  { id: 'plot-003', plotId: 'NYD-MTH-B2-R1-009', cemetery: 'Mthatha', block: 'B2', row: 'R1', plotNumber: '009', gpsLat: '-31.5901', gpsLng: '28.7855', status: 'occupied', deceasedName: 'Thandi Nxumalo', burialDate: '02 Aug 2026', ownerName: 'Musa Nxumalo', ownerContact: '073 456 7890', reservedUntil: '—', size: 'Standard', section: 'General' },
  { id: 'plot-004', plotId: 'NYD-MTH-B3-R2-014', cemetery: 'Mthatha', block: 'B3', row: 'R2', plotNumber: '014', gpsLat: '-31.5910', gpsLng: '28.7862', status: 'reserved', deceasedName: '—', burialDate: '—', ownerName: 'Zanele Dlamini', ownerContact: '082 123 4567', reservedUntil: '06 Aug 2026', size: 'Standard', section: 'General' },
  { id: 'plot-005', plotId: 'NYD-MTH-B4-R3-022', cemetery: 'Mthatha', block: 'B4', row: 'R3', plotNumber: '022', gpsLat: '-31.5920', gpsLng: '28.7870', status: 'reserved', deceasedName: 'Nokwanda Zulu', burialDate: '04 Aug 2026', ownerName: 'Siphamandla Zulu', ownerContact: '084 987 6543', reservedUntil: '04 Aug 2026', size: 'Standard', section: 'General' },
  { id: 'plot-006', plotId: 'NYD-MTH-C1-R4-031', cemetery: 'Mthatha', block: 'C1', row: 'R4', plotNumber: '031', gpsLat: '-31.5930', gpsLng: '28.7880', status: 'reserved', deceasedName: 'Nomvula Dlamini', burialDate: '05 Aug 2026', ownerName: 'Lungelo Dlamini', ownerContact: '076 543 2109', reservedUntil: '05 Aug 2026', size: 'Standard', section: 'General' },
  { id: 'plot-007', plotId: 'NYD-LIB-A2-R1-007', cemetery: 'Libode', block: 'A2', row: 'R1', plotNumber: '007', gpsLat: '-31.6104', gpsLng: '28.9201', status: 'occupied', deceasedName: 'Bongani Ntanzi', burialDate: '04 Aug 2026', ownerName: 'Zanele Ntanzi', ownerContact: '071 234 5678', reservedUntil: '—', size: 'Standard', section: 'General' },
  { id: 'plot-008', plotId: 'NYD-LIB-A3-R2-018', cemetery: 'Libode', block: 'A3', row: 'R2', plotNumber: '018', gpsLat: '-31.6110', gpsLng: '28.9210', status: 'reserved', deceasedName: 'Sipho Khumalo', burialDate: '05 Aug 2026', ownerName: 'Nokuthula Khumalo', ownerContact: '083 456 7891', reservedUntil: '05 Aug 2026', size: 'Standard', section: 'General' },
  { id: 'plot-009', plotId: 'NYD-LIB-B2-R4-027', cemetery: 'Libode', block: 'B2', row: 'R4', plotNumber: '027', gpsLat: '-31.6120', gpsLng: '28.9220', status: 'occupied', deceasedName: 'Vusi Mkhize', burialDate: '30 Jul 2026', ownerName: 'Lindiwe Mkhize', ownerContact: '072 345 6789', reservedUntil: '—', size: 'Standard', section: 'General' },
  { id: 'plot-010', plotId: 'NYD-NGQ-A1-R2-014', cemetery: 'Ngqeleni', block: 'A1', row: 'R2', plotNumber: '014', gpsLat: '-31.6782', gpsLng: '29.0341', status: 'occupied', deceasedName: 'Lungelo Maphumulo', burialDate: '03 Aug 2026', ownerName: 'Thandi Maphumulo', ownerContact: '079 876 5432', reservedUntil: '—', size: 'Standard', section: 'General' },
  { id: 'plot-011', plotId: 'NYD-NGQ-B1-R3-011', cemetery: 'Ngqeleni', block: 'B1', row: 'R3', plotNumber: '011', gpsLat: '-31.6790', gpsLng: '29.0350', status: 'occupied', deceasedName: 'Nosipho Cele', burialDate: '01 Aug 2026', ownerName: 'Siyanda Cele', ownerContact: '066 123 4567', reservedUntil: '—', size: 'Standard', section: 'General' },
  { id: 'plot-012', plotId: 'NYD-NGQ-B2-R1-003', cemetery: 'Ngqeleni', block: 'B2', row: 'R1', plotNumber: '003', gpsLat: '-31.6800', gpsLng: '29.0360', status: 'available', deceasedName: '—', burialDate: '—', ownerName: '—', ownerContact: '—', reservedUntil: '—', size: 'Standard', section: 'General' },
];

const STATUS_FILTERS = ['All', 'Available', 'Occupied', 'Reserved', 'Transferred'];
const CEMETERY_FILTERS = ['All Cemeteries', 'Mthatha', 'Libode', 'Ngqeleni'];

export default function GravePlotContent() {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [cemeteryFilter, setCemeteryFilter] = useState('All Cemeteries');
  const [viewMode, setViewMode] = useState<'table' | 'grid'>('table');
  const [qrPlot, setQrPlot] = useState<GravePlot | null>(null);
  const [transferPlot, setTransferPlot] = useState<GravePlot | null>(null);

  const filtered = useMemo(() => {
    return gravePlots.filter((p) => {
      const matchStatus = statusFilter === 'All' || p.status === statusFilter.toLowerCase();
      const matchCem = cemeteryFilter === 'All Cemeteries' || p.cemetery === cemeteryFilter;
      const matchSearch =
        !search ||
        p.plotId.toLowerCase().includes(search.toLowerCase()) ||
        p.deceasedName.toLowerCase().includes(search.toLowerCase()) ||
        p.ownerName.toLowerCase().includes(search.toLowerCase());
      return matchStatus && matchCem && matchSearch;
    });
  }, [search, statusFilter, cemeteryFilter]);

  const statusCounts = useMemo(() => {
    const c: Record<string, number> = { All: gravePlots.length };
    STATUS_FILTERS.slice(1).forEach((s) => {
      c[s] = gravePlots.filter((p) => p.status === s.toLowerCase()).length;
    });
    return c;
  }, []);

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-700 text-foreground">Grave Plot Management</h1>
          <p className="text-sm text-muted-foreground mt-0.5">Manage all plots across Nyandeni cemeteries</p>
        </div>
        <div className="flex items-center gap-2">
          <button className="btn-ghost text-sm border border-border"><QrCode size={14} /> Scan QR</button>
          <button className="btn-primary text-sm"><Plus size={15} /> Register Plot</button>
        </div>
      </div>

      {/* Summary Row */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[
          { id: 'ps-total', label: 'Total Plots', value: '4 820', color: 'text-foreground' },
          { id: 'ps-occupied', label: 'Occupied', value: '3 214', color: 'text-foreground' },
          { id: 'ps-available', label: 'Available', value: '1 382', color: 'text-positive' },
          { id: 'ps-reserved', label: 'Reserved', value: '224', color: 'text-[#0369a1]' },
        ].map((s) => (
          <div key={s.id} className="card-base px-4 py-3">
            <p className="text-xs text-muted-foreground">{s.label}</p>
            <p className={`text-xl font-700 tabular-nums ${s.color}`}>{s.value}</p>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div className="flex items-center gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[200px] max-w-sm">
          <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search by plot ID, deceased, owner..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="input-base pl-9 text-sm"
          />
        </div>
        <select
          value={cemeteryFilter}
          onChange={(e) => setCemeteryFilter(e.target.value)}
          className="input-base w-auto text-sm"
        >
          {CEMETERY_FILTERS.map((c) => <option key={`cf-${c}`} value={c}>{c}</option>)}
        </select>
        <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
          {STATUS_FILTERS.map((s) => (
            <button
              key={`sf-${s}`}
              onClick={() => setStatusFilter(s)}
              className={`px-3 py-1 text-xs rounded font-500 transition-all ${
                statusFilter === s ? 'bg-card shadow-card text-foreground font-600' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {s} {statusCounts[s] ? `(${statusCounts[s]})` : ''}
            </button>
          ))}
        </div>
        <div className="ml-auto flex items-center gap-1 border border-border rounded-lg p-1">
          <button
            onClick={() => setViewMode('table')}
            className={`p-1.5 rounded transition-colors ${viewMode === 'table' ? 'bg-primary text-white' : 'text-muted-foreground hover:text-foreground'}`}
            title="Table view"
          >
            <List size={15} />
          </button>
          <button
            onClick={() => setViewMode('grid')}
            className={`p-1.5 rounded transition-colors ${viewMode === 'grid' ? 'bg-primary text-white' : 'text-muted-foreground hover:text-foreground'}`}
            title="Grid view"
          >
            <Grid size={15} />
          </button>
        </div>
      </div>

      {viewMode === 'table' ? (
        <PlotTable plots={filtered} onQR={setQrPlot} onTransfer={setTransferPlot} />
      ) : (
        <PlotGrid plots={filtered} onQR={setQrPlot} />
      )}

      {qrPlot && <PlotQRModal plot={qrPlot} onClose={() => setQrPlot(null)} />}
      {transferPlot && <PlotTransferModal plot={transferPlot} onClose={() => setTransferPlot(null)} />}
    </div>
  );
}

function PlotGrid({ plots, onQR }: { plots: GravePlot[]; onQR: (p: GravePlot) => void }) {
  const statusColors: Record<string, string> = {
    available: 'border-positive/40 bg-[#f0fdf4]',
    occupied: 'border-border bg-card',
    reserved: 'border-[#0369a1]/30 bg-[#f0f9ff]',
    transferred: 'border-purple-200 bg-purple-50',
  };
  const dotColors: Record<string, string> = {
    available: 'bg-positive',
    occupied: 'bg-muted-foreground',
    reserved: 'bg-[#0369a1]',
    transferred: 'bg-purple-500',
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-3">
      {plots.map((p) => (
        <div
          key={p.id}
          className={`border rounded-lg p-3 cursor-pointer hover:shadow-elevated transition-all ${statusColors[p.status] || 'border-border bg-card'}`}
        >
          <div className="flex items-center justify-between mb-2">
            <div className={`w-2 h-2 rounded-full ${dotColors[p.status] || 'bg-muted-foreground'}`} />
            <button onClick={() => onQR(p)} className="text-muted-foreground hover:text-primary transition-colors" title="View QR Code">
              <QrCode size={13} />
            </button>
          </div>
          <p className="font-mono-data text-[10px] text-muted-foreground truncate">{p.plotId}</p>
          <p className="text-xs font-600 text-foreground mt-1 truncate">
            {p.status === 'occupied' ? p.deceasedName : p.status === 'reserved' ? p.ownerName : 'Available'}
          </p>
          <p className="text-[11px] text-muted-foreground mt-0.5">{p.cemetery}</p>
        </div>
      ))}
    </div>
  );
}